export default function Differentials() {
  const differentials = [
    {
      id: 1,
      icon: "ri-user-heart-line",
      title: "Planejamento Personalizado",
      description: "Cada protocolo é pensado de forma individual, respeitando objetivos, histórico e características corporais únicas de cada paciente."
    },
    {
      id: 2,
      icon: "ri-award-line",
      title: "Técnica Especializada",
      description: "Procedimentos avançados para remodelação glútea, contorno corporal, emagrecimento e performance com segurança e precisão."
    },
    {
      id: 3,
      icon: "ri-heart-pulse-line",
      title: "Resultados Naturais",
      description: "Foco em harmonização, proporção e naturalidade, valorizando a beleza feminina com equilíbrio, definição e sustentação dos resultados."
    }
  ];

  return (
    <section className="bg-white py-20 px-5 sm:px-8 lg:px-16">
      <div className="max-w-5xl mx-auto">

        {/* Header */}
        <div className="flex items-center gap-3 mb-10">
          <div className="w-8 h-px bg-[#C9A84C]"></div>
          <span className="text-[#C9A84C] text-xs tracking-[0.25em] uppercase font-semibold" style={{ fontFamily: 'DM Sans, sans-serif' }}>
            Diferenciais
          </span>
        </div>

        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a1a1a] mb-12 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
          Por que escolher a<br />
          <span className="italic text-[#C9A84C]">Léo Dra. Bumbum</span>
        </h2>

        {/* Differentials grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-16">
          {differentials.map((diff) => (
            <div
              key={diff.id}
              className="bg-[#faf8f5] border border-[#e8dfc8] rounded-2xl px-6 py-8 hover:border-[#C9A84C]/60 hover:bg-[#fdf9f0] hover:shadow-lg transition-all duration-300 group"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-[#C9A84C]/10 mb-5 group-hover:bg-[#C9A84C]/20 transition-all duration-300">
                <i className={`${diff.icon} text-[#C9A84C] text-2xl`}></i>
              </div>
              <h3 className="text-[#1a1a1a] text-lg font-semibold mb-3 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
                {diff.title}
              </h3>
              <p className="text-[#888] text-sm leading-relaxed" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                {diff.description}
              </p>
            </div>
          ))}
        </div>

        {/* Image banner */}
        <div className="relative rounded-3xl overflow-hidden shadow-xl" style={{ height: '280px' }}>
          <img
            src="/img/ex.jpg"
            alt="Excelência em cada detalhe"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <p className="text-white text-2xl sm:text-3xl lg:text-4xl font-bold italic text-center px-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Excelência em cada detalhe
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}